import {
  IBrandBySubRetailIn,
  IBrandByPosIn,
  IBrandByCountryIn,
} from "../../models/dto/surveyApi/IBrandsDto";
import * as ApiWithToken from "../callApiWithToken";

const brandsService = {
  getBrands: async function (languageID: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `BrandsNew/GetBrands?languageId=${languageID}`
    );
  },
  getBrandsByCountry: async function (countryID: number, languageID: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `BrandsNew/GetBrandsByCountry?countryID=${countryID}&languageID=${languageID}`
    );
  },
  getBrandsBySubretail: async function (
    subRetailID: number,
    languageID: number
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `BrandsNew/GetBrandsBySubretail?subRetailID=${subRetailID}&languageID=${languageID}`
    );
  },
  getBrandsByPos: async function (posCode: string, languageID: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `BrandsNew/GetBrandsByPos?posCode=${posCode}&languageId=${languageID}`
    );
  },
  insertBrandByCountry: async function (brandCountryIn: IBrandByCountryIn[]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_SURVEY_API + `BrandsNew/InsertBrandByCountry`,
      brandCountryIn
    );
  },
  insertBrandBySubretail: async function (
    brandSubretailIn: IBrandBySubRetailIn[]
  ) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_SURVEY_API + `BrandsNew/InsertBrandBySubretail`,
      brandSubretailIn
    );
  },
  insertBrandByPos: async function (json: IBrandByPosIn[]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_SURVEY_API + `BrandsNew/InsertBrandByPos`,
      json
    );
  },
  deleteBrandByCountry: async function (brandId: number, countryId: number) {
    return ApiWithToken.deleteApi(
      process.env.REACT_APP_SURVEY_API +
        `BrandsNew/DeleteBrandByCountry?brandId=${brandId}&countryId=${countryId}`
    );
  },
  deleteBrandBySubretail: async function (
    brandId: number,
    subretailId: number
  ) {
    return ApiWithToken.deleteApi(
      process.env.REACT_APP_SURVEY_API +
        `BrandsNew/DeleteBrandBySubretail?brandId=${brandId}&subretailId=${subretailId}`
    );
  },
  deleteBrandByPos: async function (brandId: number, posCode: string) {
    return ApiWithToken.deleteApi(
      process.env.REACT_APP_SURVEY_API +
        `BrandsNew/DeleteBrandByPos?brandId=${brandId}&posCode=${posCode}`
    );
  },
  updateBrandByCountry: async function (json: IBrandByCountryIn[]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_SURVEY_API + `BrandsNew/UpdateBrandByCountry`,
      json
    );
  },
  updateBrandBySubRetail: async function (json: IBrandBySubRetailIn[]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_SURVEY_API + `BrandsNew/UpdateBrandBySubRetail`,
      json
    );
  },
  updateBrandByPos: async function (json: IBrandByPosIn[]) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_SURVEY_API + `BrandsNew/UpdateBrandByPos`,
      json
    );
  },
};
export default brandsService;
